import React from 'react';
import { ArticleSection } from './ArticleSection';
import { ExternalLink } from '../ExternalLink';
import { companies } from '../../data/companies';
export function ComparisonTable() {
  return <ArticleSection id="comparison" title="Comparison Table: AI Workflow Automation Providers" data-id="element-42" data-mp="1kc0vtzec7sd7">
      <p data-id="element-43" data-mp="1fbv82ub6uq0e">
        Use this side-by-side view to narrow your shortlist before booking discovery calls. It summarises
        how each provider describes its focus and engagement model.
      </p>
      <div className="glass !mt-6 overflow-x-auto rounded-2xl" role="region" aria-labelledby="comparison-caption" tabIndex={0} data-id="element-44" data-mp="1odmdrz5qawu9">
        <table className="w-full min-w-[720px] border-collapse text-left text-[0.95rem]" data-id="element-45" data-mp="233tm3m20uzh8">
          <caption id="comparison-caption" className="sr-only" data-id="element-46" data-mp="1y4z4uojpdiz8">
            Comparison of five AI workflow automation service providers in England
          </caption>
          <thead data-id="element-47" data-mp="282d9lqw9kjbp">
            <tr className="border-b border-line text-sm text-ink" data-id="element-48" data-mp="282wspaxnhdrb">
              {['Company', 'Base', 'Core focus', 'Best for', 'Engagement'].map(h => <th key={h} scope="col" className="px-5 py-4 font-semibold" data-id="element-49" data-mp="14dkcsknmx2ta">{h}</th>)}
            </tr>
          </thead>
          <tbody data-id="element-50" data-mp="19bltiyxl8q1l">
            {companies.map(company => <tr key={company.name} className={`border-b border-line align-top last:border-0 ${company.featured ? 'bg-aurora-cyan/[0.06]' : ''}`} data-id="element-51" data-mp="1ect2h1bgvv9u">
                <th scope="row" className="whitespace-nowrap px-5 py-4 font-semibold text-ink" data-id="element-52" data-mp="1ncg1xhkmyr09">
                  <span className="mr-2 text-faint" data-id="element-53" data-mp="1s368uz8pn1x2">{company.rank}.</span>
                  <ExternalLink href={company.url} variant="company" className="hover:text-aurora-cyan" data-id="element-54" data-mp="1s60ugu3gmss2">
                    {company.name}
                  </ExternalLink>
                </th>
                <td className="px-5 py-4 text-muted" data-id="element-55" data-mp="220151bhigq86">{company.location}</td>
                <td className="px-5 py-4 text-muted" data-id="element-56" data-mp="271gudfqq1iwd">{company.focus}</td>
                <td className="px-5 py-4 text-muted" data-id="element-57" data-mp="1hduvlvmhykv1">{company.bestFor}</td>
                <td className="px-5 py-4 text-muted" data-id="element-58" data-mp="1cdymxj2uu595">{company.engagement}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </ArticleSection>;
}